module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-1"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("ONE")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("“Dr. Jamison")]), _vm._v(" to O.R. 8 stat. Dr. Jamison to O.R. 8 stat,” a man’s voice blared over the intercom. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And showtime,” Lani called over her shoulder to Sandra, one of the veteran prenatal nurses, as she sprinted in the designated direction. Thoughts of checking on the newborns who came into the world last night would have to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The silver doors to the scrub zone of the operating room hit the walls with a thud as Lani rushed to wash her hands and arms, gloved up, and slip on a mask and gown. She scanned the area. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Where is everyone?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In a flash, someone shot past her, bursting out of the room so violently that the doors slammed against the walls and vibrated the entire area.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lani swept into the operating room and froze. No nurses clamored with instruments while prepping a patient. No other doctors barked orders. The silence was unnatural.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What the hell?” she whispered, then lowered her gaze. “Oh, God!” Lani rushed to the cloth-covered table and shuddered with disbelief. A tiny form in pink lay there, blood dripping at a fast clip from those delicate wrists. With a gasp, Lani smacked the alarm on the wall to put the entire hospital and security on high alert. She rushed back to the baby and worked feverishly to stem the flow of blood from its injuries. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("In seconds, the crash doors burst open. Sandra and a newer nurse, Jennifer, jumped into the fray. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Quick,” Lani commanded. “Get me sutures and number four silk. We have to stop this bleeding. Call downstairs and have them get some blood up here, pronto.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sandra was on it, the worry lines in her forehead more pronounced.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I need vitals. Now,” Lani demanded. “Check her pressure. Bring over that oxygen mask. I don’t like her color.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jennifer rushed to comply with the rapid-fire instructions, selecting a mask specifically for newborns. Behind them, thundering footsteps echoed in the operating room. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Someone tried to kill this child,” Lani exclaimed to a big bear of a man who almost filled the doorway. “Alert security to get the police and seal off the pediatric wing to everyone except approved personnel.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The man barreled out of the room. ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Come on, little one,” Lani soothed. “Stay with us.” Her head snapped toward Sandra. “Vitals?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Blood pressure is faint. The heart is fighting like hell to keep pumping.” She carefully massaged the small chest. “What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I don’t know,” Lani replied as she worked in tandem with Sandra. She injected the numbing agent into the skin near the open wound. “Start an IV so we can begin the transfusion. We have to get her hydrated. I don’t know how long she was in here before I arrived.” ")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“BP’s rising,” Jennifer offered, an unmistakable thread of hope in her voice. “Come on, baby girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sandra stroked the child’s tiny head. “Her color’s improving. She’s a fighter.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lani glanced up, whispering, “Yes, she is,” then returned to suturing. “But no innocent baby should have to fight this hard when they just got here.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e09b994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter001.vue
// module id = 72
// module chunks = 0